exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!bootstrap/dist/css/bootstrap.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!font-awesome/css/font-awesome.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  padding-top: 80px; }\n\n.navbar-light .navbar-brand {\n  color: #1d3b48; }\n\n.list-group-item.active {\n  background-color: #1d3b48;\n  border-color: #1d3b48; }\n\nbutton {\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/React/Antique/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/React/Antique/~/postcss-loader?{"ident":"postcss"}!C:/React/Antique/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/React/Antique/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 2